import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import { useNextPlan, usePlanStacks } from "@zapier/upsells/esm/hooks";
import { getNextPlanTypeForUpgradeReason } from "@zapier/upsells/esm/utils";
export const usePlanForUpgradeReason = ({ account, activeTrialType, upgradeReason, useQuery = defaultUseQuery, }) => {
    var _a;
    const { error: planStacksError, isLoading: isLoadingPlanStacks, planStacks, } = usePlanStacks({ useQuery });
    let planType;
    if ((account === null || account === void 0 ? void 0 : account.plan) && planStacks && planStacks.length > 0) {
        planType = getNextPlanTypeForUpgradeReason({
            activeTrialType,
            currentPlan: account === null || account === void 0 ? void 0 : account.plan,
            planStacks,
            upgradeReason,
        });
    }
    const { error: planError, isLoading: isLoadingPlan, nextPlan: plan, } = useNextPlan({
        accountId: account === null || account === void 0 ? void 0 : account.id,
        interval: (_a = account === null || account === void 0 ? void 0 : account.plan) === null || _a === void 0 ? void 0 : _a.interval,
        skip: !account || !planType || isLoadingPlanStacks,
        type: planType,
        useQuery,
    });
    const isLoading = !account || isLoadingPlan || isLoadingPlanStacks;
    return {
        error: (!planType && !isLoading) || planError || planStacksError
            ? "An error has occurred. Please try again."
            : undefined,
        isLoading,
        plan,
    };
};

// @zapier/upsells@8.0.3 (1de7a616e)
